import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/**
 * 画像関連サービス.
 */
@Injectable()
export class ImageService {

  /**
   * コンストラクタ.
   */
  constructor() { }

  /**
   * 画層ファイルをBASE64形式に変換します.
   *
   * @param file 画像ファイル
   */
  convertToBase64Format(file: File): Observable<Base64Image> {

    return new Observable(observer => {
      const reader: FileReader = new FileReader();
      reader.onloadend = function (progressEvent: ProgressEvent) {

        // 読み込み結果をMIMEタイプとデータに分割する
        let tmp = reader.result.split(',');
        const data = tmp[1];
        tmp = tmp[0].split(';');
        tmp = tmp[0].split(':');
        const mimeType = tmp[1];

        const base64Image = {
          fileName: file.name,
          mimeType: mimeType,
          data: data
        };
        observer.next(base64Image);
      };
      reader.readAsDataURL(file);
    });
  }

  /**
   * BASE64形式画像データを生データに戻します.
   *
   * @param base64Image BASE64形式画像データ
   */
  revertRawData(base64Image: Base64Image): string {
    return 'data:' + base64Image.mimeType + ';base64,' + base64Image.data;
  }
}

/**
 * BASE64形式画像データ.
 */
export interface Base64Image {

  /** ファイル名. */
  fileName: string;

  /** MIMEタイプ. */
  mimeType: string;

  /** BASE64形式の画像データ. */
  data: string;
}



// WEBPACK FOOTER //
// ./src/app/common-app/service/image.service.ts